<template>
  <div class="verification-form-common-risk app-key-value__list">
    <div class="verification-cdd-form__questions-list">
      <h3 class="verification-cdd-form__title">
        {{ "verification-bdd-customer-risk-factors.title" | globalize }}
      </h3>

      <template v-for="(value,key) in form">
        <verification-form-question
          v-model="form[key]"
          :key="key"
          :input="former.setAttr(`customerRiskFactors.${key}`, value)"
          :question-message="
            `verification-bdd-customer-risk-factors.bdd-crf-${key}` | globalize"
          :error-message="getFieldErrorMessage(`form.${key}`)"
          :disabled="isDisabled"
        />
      </template>
    </div>
  </div>
</template>

<script>
import VerificationFormQuestion from '../../VerificationCDDForm/components/VerificationFormQuestion'

import { VerificationBDDFormer } from '@/js/formers/VerificationBDDFormer'
import { required } from '@validators'
import _isEmpty from 'lodash/isEmpty'

import FormMixin from '@/vue/mixins/form.mixin'

export default {
  name: 'verification-form-bdd-customer-risk-factors',
  components: { VerificationFormQuestion },
  mixins: [ FormMixin ],
  props: {
    former: {
      type: VerificationBDDFormer,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      form: {
        qus01: this.former.attrs.customerRiskFactors.qus01,
        qus02: this.former.attrs.customerRiskFactors.qus02,
        qus03: this.former.attrs.customerRiskFactors.qus03,
        qus04: this.former.attrs.customerRiskFactors.qus04,
        qus05: this.former.attrs.customerRiskFactors.qus05,
        qus06: this.former.attrs.customerRiskFactors.qus06,
        qus07: this.former.attrs.customerRiskFactors.qus07,
      },
      isEmpty: _isEmpty,
    }
  },
  validations () {
    let form = {}
    Object.keys(this.form).forEach(key => { form[key] = { required } })

    return { form }
  },

  methods: {
    isArray (value) {
      return Array.isArray(value)
    },
    formatData (value) {
      if (!value) {
        return '-'
      } else if (this.isArray(value)) {
        return value.join(', ')
      } else {
        return value
      }
    },
  },
}
</script>
